import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=54a475e8&scoped=true&"
import script from "./ResultsList.vue?vue&type=script&lang=js&"
export * from "./ResultsList.vue?vue&type=script&lang=js&"
import style0 from "./ResultsList.vue?vue&type=style&index=0&id=54a475e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a475e8",
  null
  
)

export default component.exports